import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";

import { debugE2E } from "@/config/environmentUtils";
import { initI18n } from "@/config/i18n";
import { initPdfWorker } from "@/config/pdfjs-worker";
import { AppNotificationProvider } from "@/modules/app-notification";
import { EventBusProvider } from "@/modules/event-bus";
import { MapProvider } from "@/modules/map";
import {
  PageErrorDevMode,
  shouldShowErrorToDeveloper,
} from "@/modules/page-error-dev-mode";
import { Router } from "@/modules/router";
import { AuthProvider } from "@/services/auth";
import { BroadcastProvider } from "@/services/broadcast";
import { initDayJs } from "@/services/dayjs";
import { QueryProvider } from "@/services/query";
import { StateProvider } from "@/services/state";
import { ThemeProvider } from "@/services/theme";

import { initGA } from "./config/ga";

initI18n();
initDayJs();
initPdfWorker();
initGA();

const container = document.getElementById("app-root");
if (!container) {
  throw new Error("App root element not found");
}
const root = createRoot(container);

root.render(
  <StrictMode>
    <ErrorBoundary
      fallbackRender={({ error }) =>
        debugE2E() || shouldShowErrorToDeveloper() ? (
          <PageErrorDevMode error={error} />
        ) : (
          "An error occurred"
        )
      }
    >
      <AuthProvider>
        <ThemeProvider>
          <QueryProvider>
            <StateProvider>
              <EventBusProvider>
                <MapProvider>
                  <BroadcastProvider>
                    <AppNotificationProvider>
                      <Router />
                    </AppNotificationProvider>
                  </BroadcastProvider>
                </MapProvider>
              </EventBusProvider>
            </StateProvider>
          </QueryProvider>
        </ThemeProvider>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>
);
